import type { PaginatedResponse } from '@/types/common.type';

export const mapPaginatedResponse = <T, R>(mapper: (item: T) => R) => {
  return (response: PaginatedResponse<T>): PaginatedResponse<R> => ({
    data: response.data.map(mapper),
    meta: response.meta,
  });
};

export const defaultPaginatedResponse = <T>(): PaginatedResponse<T> => ({
  data: [],
  meta: {
    page: 1,
    page_size: 10,
    total_items: 0,
    total_pages: 0,
    has_next: false,
    has_previous: false,
  },
});
